import { Box } from '@mui/material'
import React, { memo } from 'react'
import { useTranslation } from 'react-i18next'

import { buildFooterSiteLinks } from '../../../util/siteLink.helpers'
import OutsideLink from '../links/OutsideLink'

const FooterLinks = () => {
  const { t } = useTranslation()
  return (
    <Box
      sx={{
        gap: 2,
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'row'
      }}
    >
      {buildFooterSiteLinks(t).map(({ label, to }) => (
        <OutsideLink
          key={label}
          href={to}
          color='inherit'
          variant='body2'
          label={label}
        />
      ))}
    </Box>
  )
}

export default memo(FooterLinks)
